import script from "./SignatureSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignatureSettings.vue?vue&type=script&setup=true&lang=ts"

import "./SignatureSettings.vue?vue&type=style&index=0&id=fc018432&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc018432"]])

export default __exports__